'use strict';

module.exports = {
    author: {
        name: 'Infomir',
        email: 'support@infomir.eu'
    },
    languages: ['de', 'el', 'es', 'fr', 'it', 'nl', 'pl', 'ru', 'et', 'lv', 'sl', 'uk', 'hy', 'ka', 'bg', 'tr', 'pt', 'az'],
    license: 'license.md',
    order: [
        'magcore-app-tv',
        'magcore-app-tv-classic',
        'magcore-app-dvb',
        'magcore-app-video-club',
        'magcore-app-video-club-prime',
        'magcore-app-radio',
        'magcore-app-magic-cast',
        'magcore-app-audio-club',
        'magcore-app-explorer',
        'magcore-app-records',
        'magcore-app-weather',
        'magcore-app-personal-account',
        'magcore-app-settings',
        'magcore-app-browser',
        'magcore-app-downloads',
        'magcore-app-karaoke',
        'magcore-app-lines',
        'magcore-app-sudoku',
        'magcore-app-memory',
        'magcore-app-2048'
    ],
    resolutions: ['480', '576', '720', '1080'],
    source: 'src'
};
